'use client';

import * as React from 'react';

/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */
const ImageListContext = /*#__PURE__*/React.createContext({});
if (process.env.NODE_ENV !== 'production') {
  ImageListContext.displayName = 'ImageListContext';
}
export default ImageListContext;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/ImageList/ImageListContext.js
// module id = 930
// module chunks = 25